import { connectAndForwardRef } from 'util/redux'
import { selectAccountChatRoomId } from 'selectors/app/selectAccountPreferences'
import {
  selectCurrentUserPrefersChatAutoAssignOnReply,
  selectCurrentUserPrefersChatAutoAssignOnNote,
} from 'ducks/currentUser/selectors/preferences'
import { selectIsChatAvailableForCurrentWidget } from 'ducks/widgets/selectors'
import SendMessageComposerView from './view'

const select = state => ({
  accountChatRoomId: selectAccountChatRoomId(state),
  autoAssignOnReply: selectCurrentUserPrefersChatAutoAssignOnReply(state),
  autoAssignOnNote: selectCurrentUserPrefersChatAutoAssignOnNote(state),
  enabled: selectIsChatAvailableForCurrentWidget(state),
})

export default connectAndForwardRef(select)(SendMessageComposerView)
